export default class ScrollWatcher {
  constructor(before, after, options = {}) {
    // Callbacks
    this.before = before;
    this.after = after;
    
    // Options
    this.delay = options.delay || 50;
    this.distance = options.distance || 100;

    // Unblock
    this.allow();

    if (options.onload) {
      this.scroll();
    }

    this.watch();
  }

  allow() {
    this.blocked = false;
  }

  block() {
    this.blocked = true;
    setTimeout(this.allow.bind(this), this.delay);
  }

  watch() {
    $(document).scroll(this.scroll.bind(this));
  }

  scroll() {
    // Performance
    if (this.blocked) return;

    this.block();

    // Check distance to top
    let distance = $(document).scrollTop();

    if (this.active && distance < this.distance) {
      this.active = false;
      this.before();
    }

    if (! this.active && distance >= this.distance) {
      this.active = true;
      this.after();
    }
  }
}